<template>
    <div>
        <LoaderComponent v-if="loading" />
        <div v-else>
            <div v-if="errors.fetchAccount" class="alert alert-danger">
                {{ errors.fetchAccount }}
            </div>
            <div v-else class="default-home account-page" :style="themePageStyle">
                <div class="account-page-header">
                    <div>
                        <span class="account-page-kicker">{{ themeBrandName }}</span>
                        <h1>Profil</h1>
                        <p>Gérez vos informations personnelles et de facturation.</p>
                    </div>
                </div>

                <div v-if="errors.form" class="alert alert-danger">
                    <p v-for="error in errors.form">
                        {{ error }}
                    </p>
                </div>

                <div v-if="formSuccess" class="alert alert-success">
                    {{ formSuccess }}
                </div>

                <LoaderComponent v-if="formLoading" />
                <form v-else @submit="postForm" method="post">
                    <div class="row m-0">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="border-light b-radius-20 p-4 mb-3 account-card">
                                        <div class="row mb-2 account-card-header">
                                            <div class="col-12">
                                                <strong>{{ $tl("labels.personalInfos") }}</strong>
                                            </div>
                                        </div>
                                        <div class="account-fields-grid">
                                            <div class="row mb-2 account-field account-field-half">
                                                <div class="col-5 pt-2">
                                                    <label class="form-label" for="firstname"
                                                        >{{ $tl("labels.form.firstname") }} <small>*</small></label
                                                    >
                                                </div>
                                                <div class="col-7">
                                                    <input
                                                        :disabled="isOwner"
                                                        type="text"
                                                        name="firstname"
                                                        v-model="firstname"
                                                        id="firstname"
                                                        required
                                                        class="form-control" />
                                                </div>
                                            </div>
                                            <div class="row mb-2 account-field account-field-half">
                                                <div class="col-5 pt-2">
                                                    <label class="form-label" for="lastname"
                                                        >{{ $tl("labels.form.lastname") }} <small>*</small></label
                                                    >
                                                </div>
                                                <div class="col-7">
                                                    <input
                                                        :disabled="isOwner"
                                                        type="text"
                                                        name="lastname"
                                                        v-model="lastname"
                                                        id="lastname"
                                                        required
                                                        class="form-control" />
                                                </div>
                                            </div>
                                            <div class="row mb-2 account-field account-field-half">
                                                <div class="col-5 pt-2">
                                                    <label class="form-label" for="email">{{ $tl("labels.form.email") }} <small>*</small></label>
                                                </div>
                                                <div class="col-7">
                                                    <input
                                                        :disabled="isOwner"
                                                        type="email"
                                                        name="email"
                                                        v-model="email"
                                                        id="email"
                                                        required
                                                        class="form-control" />
                                                </div>
                                            </div>
                                            <div class="row mb-2 account-field account-field-half" v-if="!isAdmin">
                                                <div class="col-5 pt-2">
                                                    <label class="form-label mb-0" for="tel"
                                                        >{{ $tl("labels.form.phoneNumber") }} <small>*</small></label
                                                    >
                                                    <br />
                                                    <small class="text-muted">{{ $tl("infos.account.changePhoneNumber") }}</small>
                                                </div>
                                                <div class="col-7">
                                                    <vue-tel-input
                                                        :disabled="isOwner"
                                                        defaultCountry="FR"
                                                        name="telInput"
                                                        class="mb-2 form-control"
                                                        @validate="setPhoneAndCountry"
                                                        v-model="phone.raw"
                                                        :enabledCountryCode="true"
                                                        :wrapperClasses="phone.isValid === null || phone.isValid ? '' : 'border border-danger'"
                                                        inputClasses="m-0 border-0"
                                                        mode="international"
                                                        :placeholder="$t('labels.form.phoneNumber')"
                                                        required></vue-tel-input>
                                                </div>
                                            </div>
                                            <div class="row mb-2 account-field">
                                                <div class="col-5 pt-2">
                                                    <label class="form-label">
                                                        {{ $tl("labels.form.lang") }} <small>*</small>
                                                        <feather
                                                            v-if="!isAdmin"
                                                            v-tooltip="getTooltipNotice('notices.lang')"
                                                            type="info"
                                                            class="ms-1 pointer tooltip-infos" />
                                                        <ShowNewBadgeDetails badge_uuid="3c0f6651-a664-47b9-8696-ce9139dcb05b" />
                                                    </label>
                                                </div>
                                                <div class="col-7">
                                                    <select class="form-select align-middle d-inline-block mb-0" v-model="lang" required>
                                                        <option v-for="lang in ALL_LANGS" :key="lang.value" :value="lang.value">
                                                            {{ lang.label }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="has_right_to_read_subscription && !isAdmin">
                                <div class="col-12">
                                    <div class="border-light b-radius-20 p-4 mb-3 account-card">
                                        <div class="row mb-2 account-card-header">
                                            <div class="col-12">
                                                <strong>{{ $tl("labels.form.facturation.title") }}</strong>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.businessName") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input :disabled="true" type="text" name="company" v-model="company" required class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.businessType") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <select
                                                    class="form-select align-middle d-inline-block mb-0"
                                                    id="company_type"
                                                    name="companyType"
                                                    v-model="companyType"
                                                    :disabled="true"
                                                    required>
                                                    <option
                                                        v-for="businessType in ALL_BUSINESS_TYPES"
                                                        :key="businessType.value"
                                                        :value="businessType.value">
                                                        {{ getBusinessTypeLabel(businessType.value) }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.facturation.siret") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input
                                                    :disabled="true"
                                                    minlength="14"
                                                    maxlength="14"
                                                    type="text"
                                                    name="companySiret"
                                                    v-model="companySiret"
                                                    required
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.facturation.nafCode") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input
                                                    :disabled="true"
                                                    type="text"
                                                    name="companyCodeNaf"
                                                    v-model="companyCodeNaf"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.facturation.tvaNumber") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input
                                                    :disabled="true"
                                                    type="text"
                                                    name="companyCodeTva"
                                                    v-model="companyCodeTva"
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.address") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input
                                                    :disabled="true"
                                                    type="text"
                                                    name="companyAddress"
                                                    v-model="companyAddress"
                                                    required
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.postalCode") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input
                                                    :disabled="true"
                                                    type="text"
                                                    name="companyZipcode"
                                                    v-model="companyZipcode"
                                                    required
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.city") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input
                                                    :disabled="true"
                                                    type="text"
                                                    name="companyCity"
                                                    v-model="companyCity"
                                                    required
                                                    class="form-control" />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-5 pt-2">
                                                <label class="form-label">{{ $tl("labels.form.country") }} <small>*</small></label>
                                            </div>
                                            <div class="col-7">
                                                <input
                                                    :disabled="true"
                                                    type="text"
                                                    name="companyCountry"
                                                    v-model="companyCountry"
                                                    required
                                                    class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="row" v-if="isNoShow || isAdmin || !isYproxUser">
                                <div class="col-12">
                                    <div class="border-light b-radius-20 p-4 mb-3 account-card">
                                        <div class="row mb-2 account-card-header">
                                            <div class="col-12">
                                                <strong>{{ $tl("labels.form.changePassword") }}</strong>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="row mb-2">
                                                <div class="col-6 pt-2">
                                                    <label class="form-label" for="old_password">{{ $tl("labels.form.oldPassword") }}</label>
                                                </div>
                                                <div class="col-6">
                                                    <CurrentPasswordInputComponent id="old_password" v-model="old_password" name="old_password" />
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-6 pt-2">
                                                    <label class="form-label" for="account_password">{{ $tl("labels.form.newPassword") }}</label>
                                                </div>
                                                <div class="col-6">
                                                    <PasswordInputComponent id="account_password" v-model="password" />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label class="form-label" for="account_password_confirmation">{{
                                                        $tl("labels.form.newPasswordConfirm")
                                                    }}</label>
                                                </div>
                                                <div class="col-6">
                                                    <PasswordConfirmationInputComponent
                                                        id="account_password_confirmation"
                                                        :mainPassword="password"
                                                        v-model="confirm_password" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="!isWithoutAccount && !isAdmin">
                                <div class="col-12">
                                    <EditUserNotificationsSetting
                                        class="border-light b-radius-20 p-4 mb-3 account-card"
                                        :user_notifications_setting="user_notifications_setting"
                                        :enable_mail_notifications="enable_mail_notifications"
                                        :enable_notification_ringtone="enable_notification_ringtone"
                                        :tel_is_mobile="phone.isMobile"
                                        :email="email"
                                        :can-manage-recipients="isOwner"
                                        @set-property="setProperty" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 account-actions">
                        <div class="col-12">
                            <input type="submit" name="submit" value="Enregistrer" class="btn btn-success btn-circle" />
                        </div>
                    </div>
                </form>
                <AuthenticationDevices />
            </div>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "../components/LoaderComponent.vue";
import EditUserNotificationsSetting from "../components/Default/Users/EditUserNotificationsSetting.vue";
import CurrentPasswordInputComponent from "../components/forms/CurrentPasswordInputComponent.vue";
import PasswordInputComponent from "../components/forms/PasswordInputComponent.vue";
import PasswordConfirmationInputComponent from "../components/forms/PasswordConfirmationInputComponent.vue";
import LangsEnum from "../mixins/enums/LangsEnum.js";
import BusinessTypesEnum from "../mixins/enums/BusinessTypesEnum.js";
import RolesEnum from "../mixins/enums/RolesEnum.js";
import ShowNewBadgeDetails from "../components/NewBadges/showNewBadgeDetails.vue";
import AuthenticationDevices from "../components/Auth/AuthenticationDevices.vue";

export default {
    data() {
        return {
            loading: false,
            formLoading: false,
            errors: {
                fetchAccount: null,
                form: null,
            },
            formSuccess: null,
            firstname: null,
            lastname: null,
            email: null,
            tel: null,
            lang: "fr",
            company: null,
            companyType: null,
            companySiret: null,
            companyCodeNaf: null,
            companyCodeTva: null,
            companyAddress: null,
            companyZipcode: null,
            companyCity: null,
            companyCountry: null,
            old_password: null,
            password: null,
            confirm_password: null,
            enable_mail_notifications: null,
            enable_notification_ringtone: null,
            user_notifications_setting: null,
            phone: {
                raw: null,
                isValid: null,
                country: null,
                value: null,
                isMobile: false,
            },
        };
    },
    mixins: [LangsEnum, BusinessTypesEnum, RolesEnum],
    computed: {
        themePageStyle() {
            return {
                "--theme-main-color-rgb": this.$style["main-color-rgb"] || "8, 62, 96",
                "--theme-main-color-light": this.$style["main-color-light"] || "#30a4b7",
                "--theme-main-color-light-rgb": this.$style["main-color-light-rgb"] || "48, 164, 183",
                "--theme-default-page-background":
                    this.$style["default-page-background"] || "linear-gradient(180deg, #ffffff 0%, #f6fbfe 44%, #edf6fb 100%)",
            };
        },
        isAdmin() {
            return this.$store.getters["users/role"] === this.ROLE_ADMIN.value;
        },
        isOwner() {
            return this.$store.getters["users/role"] === this.ROLE_OWNER.value;
        },
        isYproxUser() {
            return this.$store.getters["users/isYproxUser"];
        },
        isWithoutAccount() {
            return this.$store.getters["users/role"] === this.ROLE_USER_WITHOUT_ACCOUNT.value;
        },
        rights: function () {
            return this.$store.getters["users/formattedRights"];
        },
        has_right_to_read_subscription() {
            return this.rights.includes("default.subscription.read") || this.isAdmin;
        },
        has_right_to_update_subscription() {
            return this.rights.includes("default.subscription.update") || this.isAdmin;
        },
    },
    methods: {
        setPhoneAndCountry(phoneObject) {
            if (phoneObject.number && phoneObject.isValid !== undefined && phoneObject.country) {
                this.phone.isValid = phoneObject.isValid;

                if (this.phone.isValid) {
                    this.phone.value = phoneObject.number;
                    this.phone.isMobile = phoneObject.type === "mobile";

                    if (phoneObject.regionCode && phoneObject.regionCode !== "") {
                        this.phone.country = phoneObject.regionCode;
                    } else {
                        this.phone.country = phoneObject.country.iso2;
                    }
                } else {
                    this.phone.isMobile = false;
                }
            } else {
                this.phone.isValid = false;
                this.phone.isMobile = false;
            }
        },
        setProperty(e) {
            this.$set(this, e.key, e.value);
        },
        initData() {
            this.loading = true;
            this.errors.fetchAccount = null;
            this.restaurant = null;

            this.httpGet("/api/account?include=user_notifications_setting", { mustReject: true })
                .then((response) => {
                    this.firstname = response.data.firstname;
                    this.lastname = response.data.lastname;
                    this.email = response.data.email;
                    this.tel = response.data.tel;
                    this.lang = response.data.lang;
                    this.company = response.data.company;
                    this.companyType = response.data.company_type;
                    this.companySiret = response.data.company_siret;
                    this.companyCodeNaf = response.data.company_code_naf;
                    this.companyCodeTva = response.data.company_code_tva;
                    this.companyAddress = response.data.company_address;
                    this.companyZipcode = response.data.company_zipcode;
                    this.companyCity = response.data.company_city;
                    this.companyCountry = response.data.company_country;
                    this.old_password = null;
                    this.password = null;
                    this.confirm_password = null;
                    this.enable_mail_notifications = response.data.enable_mail_notifications;
                    this.enable_notification_ringtone = response.data.enable_notification_ringtone;
                    this.user_notifications_setting = response.data.user_notifications_setting;
                    this.phone.raw = response.data.tel;
                })
                .catch((error) => {
                    this.errors.fetchAccount = this.getErrorMsgFromErrorResponse(error);
                })
                .finally(() => (this.loading = false));
        },
        postForm(e) {
            e.preventDefault();
            this.formLoading = true;
            this.formSuccess = null;
            this.errors.form = null;

            this.httpPut("/api/account", {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                tel: this.phone.raw,
                lang: this.lang,
                company: this.company,
                company_type: this.companyType,
                company_siret: this.companySiret,
                company_code_naf: this.companyCodeNaf,
                company_code_tva: this.companyCodeTva,
                company_address: this.companyAddress,
                company_zipcode: this.companyZipcode,
                company_city: this.companyCity,
                company_country: this.companyCountry,
                old_password: this.old_password,
                password: this.password,
                confirm_password: this.confirm_password,
                enable_mail_notifications: this.enable_mail_notifications,
                enable_notification_ringtone: this.enable_notification_ringtone,
                user_notifications_setting: this.user_notifications_setting,
                tel_country: this.phone.country,
                tel_is_valid: this.phone.isValid,
                tel_is_mobile: this.phone.isMobile,
            })
                .then((response) => {
                    if (response !== false) {
                        this.$store.dispatch("users/fetchCurrentUser", { set: true }).catch(() => false);
                        this.setUserGlobalLang(this.lang);
                    }
                })
                .finally(() => (this.formLoading = false));
        },
    },
    created() {
        this.initData();
    },
    updated() {
        if (this.$refs.vueTelInput) {
            this.$refs.vueTelInput.$el.classList.remove("vue-tel-input");
            this.$refs.vueTelInput.$refs.input.addEventListener("focus", this.onVueTelInputFocus);
            this.$refs.vueTelInput.$refs.input.addEventListener("blur", this.onVueTelInputBlur);
        }
    },
    components: {
        LoaderComponent,
        EditUserNotificationsSetting,
        CurrentPasswordInputComponent,
        PasswordInputComponent,
        PasswordConfirmationInputComponent,
        ShowNewBadgeDetails,
        AuthenticationDevices,
    },
};
</script>

<style lang="scss" scoped>
.account-page {
    max-width: 1040px;
    padding: 34px 22px 44px;
    --theme-main-color-rgb: 8, 62, 96;
    --theme-main-color-light: #30a4b7;
    --theme-main-color-light-rgb: 48, 164, 183;
    --theme-default-page-background: linear-gradient(180deg, #ffffff 0%, #f6fbfe 44%, #edf6fb 100%);
}

.account-page::before {
    position: fixed;
    inset: 60px 0 0;
    z-index: -1;
    pointer-events: none;
    content: "";
    background: var(--theme-default-page-background);
}

.account-page-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
}

.account-page-kicker {
    display: inline-flex;
    margin-bottom: 6px;
    color: var(--theme-main-color-light);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.account-page-header h1 {
    margin: 0;
    color: #17202a;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.2;
}

.account-page-header p {
    max-width: 560px;
    margin: 7px 0 0;
    color: #667085;
    font-size: 14px;
    line-height: 1.55;
}

.account-card {
    padding: 26px !important;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(var(--theme-main-color-rgb), 0.1) !important;
    border-radius: 16px !important;
    box-shadow: 0 18px 42px rgba(var(--theme-main-color-rgb), 0.08);
}

.account-card-header {
    margin-bottom: 18px !important;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(var(--theme-main-color-rgb), 0.08);
}

.account-card-header strong {
    color: #1d2939;
    font-size: 15px;
    font-weight: 800;
}

.account-field label,
.account-card label {
    margin-bottom: 6px;
    color: #344054;
    font-size: 12px;
    font-weight: 750;
}

.account-card .form-control,
.account-card .form-select,
.account-card :deep(.vue-tel-input) {
    min-height: 40px;
    border-color: rgba(var(--theme-main-color-rgb), 0.14);
    border-radius: 10px;
    box-shadow: none;
}

.account-card .form-control:focus,
.account-card .form-select:focus {
    border-color: rgba(var(--theme-main-color-rgb), 0.36);
    box-shadow: 0 0 0 3px rgba(var(--theme-main-color-rgb), 0.08);
}

.account-card .form-control:disabled,
.account-card .form-select:disabled {
    color: #667085;
    background-color: #f7fafc;
}

.account-actions {
    position: sticky;
    bottom: 0;
    padding: 14px 0 4px;
    background: linear-gradient(180deg, rgba(244, 249, 252, 0), rgba(244, 249, 252, 0.96) 34%, rgba(244, 249, 252, 0.98));
}

.account-actions .btn {
    padding: 10px 20px;
    border-radius: 999px;
    box-shadow: 0 12px 24px rgba(var(--theme-main-color-light-rgb), 0.18);
}

@media (min-width: 768px) {
    .account-fields-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px 20px;
    }

    .account-field {
        display: block;
        margin: 0 !important;
    }

    .account-field > [class*="col-"] {
        width: 100%;
        max-width: 100%;
        padding: 0;
    }

    .account-field .pt-2 {
        padding-top: 0 !important;
    }

    .account-field:not(.account-field-half) {
        grid-column: 1 / -1;
    }
}

@media (max-width: 767px) {
    .account-page {
        padding: 24px 14px 34px;
    }

    .account-page-header h1 {
        font-size: 24px;
    }

    .account-card {
        padding: 20px !important;
        border-radius: 14px !important;
    }
}
</style>
